<template>
  <div ref="fbFansContainer">
    <iframe
      :src="src"
      :width="fbWidth"
      :height="fbHeight"
      title="fbIframe"
      style="border: none; overflow: hidden"
      allowfullscreen="true"
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
    ></iframe>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue';
const props = defineProps({
  fanSrc: {
    type: String,
    default: 'https://www.facebook.com/facebook',
  },
  appId: {
    type: String,
    default: '4938830502830980',
  },
});
const src = ref('');
const fbWidth = ref(0);
const fbHeight = ref(0);
const fbFansContainer = ref<HTMLElement>();

const setFbFans = () => {
  const ele = fbFansContainer.value;
  if (!ele) return;

  const { width, height } = ele.getBoundingClientRect();
  if (!width || !height) return;
  if (fbWidth.value === width && fbHeight.value === height) return;

  fbWidth.value = Math.floor(width);
  fbHeight.value = Math.floor(height);
  src.value =
    `https://www.facebook.com/plugins/page.php` +
    `?href=${encodeURIComponent(props.fanSrc)}` +
    `&tabs=timeline` +
    `&width=${fbWidth.value}` +
    `&height=${fbHeight.value}` +
    `&small_header=true` +
    `&adapt_container_width=true` +
    `&hide_cover=false` +
    `&show_facepile=true` +
    `&appId=${props.appId}`;
};

const autoResetFbFansSize = () => {
  let timer;
  window.addEventListener('resize', () => {
    clearTimeout(timer);
    timer = setTimeout(setFbFans, 600);
  });
};

onMounted(() => {
  setFbFans();
  autoResetFbFansSize();
});
</script>
